import React from 'react'

import { motion } from 'framer-motion'
import { Button, Modal, ModalBody, useDisclosure } from '@nextui-org/react'



function ProjectPage() {

    const {isOpen, onOpen, onOpenChange} = useDisclosure();


  return (

    <>
    
    
    <Button onPress={onOpen}>Open Modal</Button>

    <Modal isOpen={isOpen} className='h-4'>

        <ModalBody>
            <h1>Test</h1>
        </ModalBody>

    </Modal>
    </>


  )
}

export default ProjectPage